if (!customElements.get('universities-slider')) {
  customElements.define(
    'universities-slider',
    class UniversitiesSlider extends HTMLElement {
      constructor() {
        super();
        this.STORAGE_KEY = 'cn_favorite_university';
        this.track = null;
        this.viewport = null;
        this.nextBtn = null;
        this.prevBtn = null;
        this.selectedImg = null;
        this.selectedPlaceholder = null;
        this.selectedName = null;
        this.changeBtn = null;
        this.items = [];
      }

      connectedCallback() {
        this.track = this.querySelector('.universities-slider__track');
        this.viewport = this.querySelector('.universities-slider__viewport');
        this.nextBtn = this.querySelector('.universities-slider__btn-next');
        this.prevBtn = this.querySelector('.universities-slider__btn-prev');
        this.selectedImg = this.querySelector('.universities-slider__selected-img');
        this.selectedPlaceholder = this.querySelector('.universities-slider__selected-placeholder');
        this.selectedName = this.querySelector('.universities-slider__selected-name');
        this.changeBtn = this.querySelector('.universities-slider__change-btn');
        this.items = Array.from(this.querySelectorAll('.universities-slider__item'));

        this.loadFavorite();
        this.bindEvents();

        // Double rAF ensures layout is computed before checking overflow
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.updateArrowVisibility();

            // Re-check once all images have loaded in case they widen the track
            const images = Array.from(this.track?.querySelectorAll('img') || []);
            const pending = images.filter((img) => !img.complete);
            if (pending.length > 0) {
              Promise.all(
                pending.map((img) => new Promise((res) => { img.onload = res; img.onerror = res; }))
              ).then(() => this.updateArrowVisibility());
            }
          });
        });

        this._resizeObserver = new ResizeObserver(() => this.updateArrowVisibility());
        if (this.track) this._resizeObserver.observe(this.track);
        if (this.viewport) this._resizeObserver.observe(this.viewport);
      }

      disconnectedCallback() {
        this._resizeObserver?.disconnect();
      }

      updateArrowVisibility() {
        if (!this.track || !this.nextBtn) return;
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
        const scrolledToEnd = hasOverflow && this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        this.nextBtn.hidden = !hasOverflow || scrolledToEnd;
        if (this.prevBtn) this.prevBtn.hidden = !scrolledToEnd;
        this.viewport?.classList.toggle('universities-slider__viewport--at-end', !hasOverflow || scrolledToEnd);
        this.viewport?.classList.toggle('universities-slider__viewport--show-left-fade', scrolledToEnd);
      }

      loadFavorite() {
        try {
          const saved = localStorage.getItem(this.STORAGE_KEY);
          if (saved) {
            const data = JSON.parse(saved);
            this.updateSelectedPanel(data.name, data.logo);
            return;
          }
        } catch (_) {}

        if (this.items.length > 0) {
          const first = this.items[0];
          this.updateSelectedPanel(first.dataset.uniName, first.dataset.uniLogo);
        }
      }

      updateSelectedPanel(name, logo) {
        if (!name) return;
        if (logo && this.selectedImg) {
          this.selectedImg.src = logo;
          this.selectedImg.alt = name;
          this.selectedImg.removeAttribute('hidden');
          if (this.selectedPlaceholder) this.selectedPlaceholder.hidden = true;
        }
        if (this.selectedName) {
          this.selectedName.textContent = name;
        }
      }

      saveFavorite(name, logo) {
        try {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ name, logo: logo || '' }));
        } catch (_) {}
      }

      bindEvents() {
        this.nextBtn?.addEventListener('click', () => {
          if (!this.track) return;
          this.track.scrollBy({ left: 280, behavior: 'smooth' });
        });

        this.prevBtn?.addEventListener('click', () => {
          if (!this.track) return;
          this.track.scrollBy({ left: -280, behavior: 'smooth' });
        });

        this.track?.addEventListener('scroll', () => {
          if (!this.track || !this.nextBtn) return;
          const scrolledToEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
          this.nextBtn.hidden = scrolledToEnd;
          if (this.prevBtn) this.prevBtn.hidden = !scrolledToEnd;
          this.viewport?.classList.toggle('universities-slider__viewport--at-end', scrolledToEnd);
          this.viewport?.classList.toggle('universities-slider__viewport--show-left-fade', scrolledToEnd);
        });

        this.items.forEach((item) => {
          item.addEventListener('click', () => {
            const name = item.dataset.uniName;
            const logo = item.dataset.uniLogo;
            this.saveFavorite(name, logo);
            this.updateSelectedPanel(name, logo);
          });
        });

        this.changeBtn?.addEventListener('click', () => {
          this.track?.scrollTo({ left: 0, behavior: 'smooth' });
        });
      }
    }
  );
}
